var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('button',{staticClass:"backbutton",on:{"click":function($event){return _vm.goBack()}}},[_c('img',{attrs:{"src":_vm.imagePath(_vm.backbutton)}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }